<template>
  <div
    v-if="back || next"
    class="tw-p-10 tw-fixed tw-bottom-0 tw-w-screen tw-z-20 menuSection"
  >
    <div
      class="tw-grid tw-grid-cols-1 tw-text-center"
      :class="{ 'tw-grid-cols-2 tw-gap-10': this.back && this.next }"
    >
      <div v-if="this.back">
        <button class="btnCustom" @click="btnVoltar()">Voltar</button>
      </div>
      <div v-if="this.next">
        <button
          class="btnCustom"
          :class="{
            disabled: !validNext,
            'animate__animated animate__pulse animate__slow animate__infinite':
              validNext,
          }"
          animate__pulse
          :disabled="!validNext"
          @click="btnProximo()"
        >
          Próximo
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  setEtapaCompra,
  updateCompraInterface,
  incrementarUsosCupom,
} from "@/service/firebase";
import { registrarCompraGratuita } from "@/service/purchasePayment";

export default {
  props: {
    validNext: {
      type: Boolean,
      default: true,
    },
    back: {
      type: Boolean,
      default: true,
    },
    next: {
      type: Boolean,
      default: true,
    },
    destinoBack: {
      type: String,
      default: "",
    },
    destinoNext: {
      type: String,
      default: "",
    },
  },
  methods: {
    async btnProximo() {
      if (!this.destinoNext) {
        this.$root.infoModal(
          "Não foi possível encontrar o destino do botão proximo"
        );
        return false;
      }

      const chapters = this.$root.chapters();
      const compra = this.$store.getters["compra/getCompra"];

      if (
        this.destinoNext === chapters.PAGAMENTO_PROCESSO &&
        compra.valor === 0
      ) {
        await this.processarPagamentoGratis(compra);
        return;
      }

      // Fluxo normal
      setEtapaCompra(this.destinoNext);
    },

    async processarPagamentoGratis(compra) {
      try {
        if (compra.cupom && compra.cupom.id) {
          await incrementarUsosCupom(compra.cupom.id);
        }

        registrarCompraGratuita(compra);
        this.$store.commit("compra/setCompra", compra);
        await updateCompraInterface(compra);

        setEtapaCompra(this.$root.chapters().PAGAMENTO_SUCESSO);
      } catch (error) {
        console.error("Erro ao processar pagamento grátis:", error);
        this.$root.infoModal("Erro ao processar cupom grátis");
      }
    },

    btnVoltar() {
      if (!this.destinoBack) {
        this.$root.infoModal(
          "Não foi possível encontrar o destino do botão voltar"
        );
        return false;
      }
      setEtapaCompra(this.destinoBack);
      // Navegação imediata para home quando cancelar, não depender só do listener Firestore
      if (this.destinoBack === "CANCELADA" || this.destinoBack === "EXPIROU") {
        this.$root.goto("/cabine/home");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.menuSection {
  background: #cf8aac;
  box-shadow: 0px -8px 8px rgba(140, 38, 103, 0.2);
}
.btnCustom {
  background: #8c2667;
  box-shadow: 0px 4px 8px rgba(162, 134, 199, 0.25);
  border-radius: 8px;
  @apply tw-p-8 tw-w-full tw-text-white tw-cursor-pointer tw-font-bold tw-text-3xl;
  &.disabled {
    @apply tw-opacity-50;
  }
}
.menuBG {
  background-color: #cf8aac;
}
</style>
